import { Box, Stack } from "@mui/material";
import { DL38299Form as DL38299FormType } from "../../../types/forms/capture";
import { DL38299 } from "../../../types/model/dl38299";
import DL38299Form from "./DL38299Form";

interface CaptureDL38299Props {
  DL38299Data?: DL38299 | null;
  canEdit: boolean;
  onCreate: (values: DL38299FormType) => Promise<void>;
  onUpdate: (DL38299id: number, values: DL38299FormType) => Promise<void>;
}

export default function CaptureDL38299({
  DL38299Data,
  canEdit,
  onCreate,
  onUpdate
}: Readonly<CaptureDL38299Props>) {
  const isExisting = !!DL38299Data;

  return (
    <Stack spacing={2}>
      <Box sx={{ mb: 20 }}>
        <DL38299Form
          DL38299Data={DL38299Data}
          canEdit={canEdit}
          onSubmit={async (values) => {
            if (isExisting && DL38299Data?.id) {
              await onUpdate(DL38299Data.id, values);
            } else {
              await onCreate(values);
            }
          }}
        />
      </Box>
    </Stack>
  );
}